import React, { memo, useState } from 'react';

import { Message } from '@common/components/form/message';
import { SelectInput } from '@common/components/form/inputs/select';
import NumberInput from '@common/components/form/inputs/number';
import Icon from '../icon';

import './interval-input.scss';

export type IntervalInputProps = {
  name: string;
  max?: number;
  min: number;
  id: string;
  disabled?: boolean;
  options: {
    label: string;
    value: string;
  }[];
  onDelete: (id: string) => void;
};

const MIN = 0;

/**
 * Currently this input component is only used in combination with redux-form.
 * <InputElements /> wraps the input elements in the <Field /> redux-form wrapper.
 * If we would like to support react-hook-form in the future, we should create
 * an additional wrapper component.
 * See https://linear.app/oneteam/issue/ONE-1233/create-event-form-make-notification-input-library-agnostic
 */
const IntervalInput = memo(({
  id, name, min, max, disabled, options, onDelete,
}: IntervalInputProps) => {
  const [warning, setWarning] = useState('');
  const [error, setError] = useState('');

  return (
    <>
      <div className="IntervalInput">
        <NumberInput
          name={`${name}.value`}
          min={min}
          max={max}
          disabled={disabled}
          onWarning={setWarning}
          onError={setError}
        />
        <SelectInput
          name={`${name}.unit`}
          options={options}
          clearable={false}
          disabled={disabled}
        />
        { !disabled && (
          <Icon type="close" size="large" onClick={() => onDelete(id)} />
        )}
      </div>
      <Message
        error={error}
        warning={warning}
        max={max}
        min={MIN}
      />
    </>
  );
});

export default IntervalInput;
